import PaddingWrap from 'components/shared/PaddingWrap';
import { Activity } from "interfaces/ActivityInterfaces";
import { useLocalization } from 'hooks/useLocalization';
import ActivityDuration from 'components/activity-display/activity-content/ActivityDuration';

interface QuickInfoBarProps {
	activity: Activity;
}

function QuickInfoBar({ activity }: QuickInfoBarProps) {
	const { getStr } = useLocalization();

	return(
		<>
			{
				activity.duration.days > 1 || activity.duration.hours || activity.duration.minutes ? (
					<div style={{ backgroundColor: '#4b71d1', color: 'white', opacity: '0.7' }}>
					<PaddingWrap short>
						<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
							<div style={{ fontWeight: 'bold' }}>
								{ getStr('Duration') }
							</div>
							<div>
								<ActivityDuration activity={activity} />
							</div>
						</div>
					</PaddingWrap>
				</div>
				) : null
			}
		</>
	);
}

export default QuickInfoBar;